export const nl = {
  ADD_COLOR_STRING_KEY: 'Voeg kleur toe',
  ADD_TEXT_KEY: 'Tekst toevoegen',
  ADD_TO_ORDER_KEY: 'Toevoegen aan bestelling',
  ADD_TO_CART: 'Toevoegen aan winkelwagentje',
  ADD_TEMPLATE: 'Sjabloon toevoegen',
  ADJUST_SIZE_KEY: 'Pas de grootte aan',
  ADJUST_TRANSPARENCY_KEY: 'Pas de transparantie aan', // Adjust Transparency
  AGREE_FOR_PRIVACY_TITLE_KEY:
    'Als u op Gereed klikt, gaat u akkoord met de gebruiksvoorwaarden en privacyverklaring van HP.',
  ALIGN_BOTTOM_KEY: 'Lijn de onderkant uit',
  ALIGN_CENTER_KEY: 'lijn het midden uit',
  ALIGN_KEY: 'richten',
  ALIGN_LEFT_KEY: 'Links uitlijnen',
  ALIGN_MIDDLE_KEY: 'uitlijnen midden',
  ALIGN_RIGHT_KEY: 'Rechts uitlijnen',
  ALIGN_TOP_KEY: 'Lijn de bovenkant uit',
  ALL_TAB_TITLE_KEY: 'Alles',

  ALMOST_DONE_TITLE_KEY: 'Bijna klaar!',
  AND_KEY: 'en',
  APPLY_KEY: 'Van toepassing zijn',
  AREA_CODE: 'Netnummer',
  BASIC_HELPER_INSTRUCTION1_KEY:
    'Blader door de inhoud en selecteer de afbeeldingen voor uw ontwerp of upload uw eigen ontwerp', // Browse the content and select the images for your design, or upload your own
  BASIC_HELPER_INSTRUCTION2_KEY:
    'Bekijk een voorbeeld van uw ontwerp of verfijn de details', // Preview your design, or fine-tune the details
  BASIC_HELPER_INSTRUCTION3_KEY:
    'Pas het ontwerp aan en voeg andere elementen toe aan uw project', // Customize the design and add other elements to your project
  BASIC_HELPER_INSTRUCTION4_KEY:
    'Wanneer het ontwerp klaar is, klikt u op VOLGENDE om een laatste controle uit te voeren en uw bestelling te plaatsen.', // When the design is ready, click NEXT to make a final check and place your order.
  BACK_KEY: 'Terug', // Back
  BACKGROUND_KEY: 'Achtergrond',
  BACKGROUND_UPPER_CASE_KEY: 'ACHTERGROND', // BACKGROUND
  BACKGROUND_CONTRAST_KEY: 'Achtergrondcontrast', // Background Contrast
  BLANK_INSPIRATION_CATEGORY_KEY:
    'Geen inspiratie gevonden onder deze categorie',
  BRING_TO_FRONT_KEY: 'Naar voorgrond',
  CANCEL_TEXT_KEY: ' Annuleren',
  CENTIMETERS_KEY: 'centimeters',
  CM_KEY: 'cm.',

  CHANGE_YOUR_SETTINGS_KEY: 'Wijzig uw projectinstellingen', // Change your project settings
  CHECKBOX_CONTENT1: 'Ik wil de Pattern Design© nieuwsbrief ontvangen', // I want to receive the Pattern Design© newsletter
  CHECKBOX_CONTENT2:
    'Ik machtig HP om namens mij een account aan te maken in Pattern Design© services', // I authorize HP to create an account in Pattern Design© services on my behalf
  CHOOSE_FROM_COMPUTER_KEY: 'Kies uit computer', // Choose from computer
  CHOOSE_RIP_OPTIONS: "Kies een van deze compatibele RIP's van derden",

  CHOOSE_FILE_KEY: 'Bestand kiezen',
  CITY: 'Stad',
  CLEAR_ALL_KEY: 'Alles wissen',
  CLEAR_COLOR_KEY: 'Heldere kleur',
  CLOSE_WINDOW_KEY: 'Venster sluiten',
  CLEAR_ALL_OBJECTS: 'Alle objecten wissen',
  CLEAR_ALL_OBJECTS_WARNING_MESSAGE:
    'Hiermee worden alle objecten op de achtergrond verwijderd.',
  CLEAR_DESIGN_KEY: 'Duidelijk ontwerp',
  COLOR_KEY: 'Kleur',
  CONTINUE_KEY: 'Doorgaan...',
  COMPANY: 'Bedrijf',
  CONGRATULATIONS_KEY: 'Gefeliciteerd!', // Congratulations!
  CONFIRM_PASSWORD: 'Confirm password', // Confirm password
  CONFIRM_PATTERN_ACCOUNT_KEY: 'Heb je nog geen Pattern Design-account?', // Don't have a Pattern Design account yet?
  CONFIRM_VECTEEZY_ACCOUNT_KEY: 'Heb je nog geen Vecteezy-account?', // Don't have a Vecteezy account yet?
  COUNTRY: 'Land', // Country
  CREATE_ACCOUNT: 'Maak account', // Create account
  COPYRIGHT_YEAR_KEY: '© 2013-{0} HPDC, L.P.',
  CUSTOM_KEY: 'Op maat',
  CUSTOM_PRICE_SIGN_IN_KEY:
    'Log in in de volgende stap om aangepaste prijzen te zien.',
  CM_UNIT_KEY: 'cm',
  CREATE_NEW: 'Maak nieuw',
  DESIGN_KEY: 'Ontwerpen',
  DELETE_KEY: 'Verwijderen',
  DOCUMENT_COLORS: 'Documentkleuren',
  DONE: 'Gedaan!',
  DONE_KEY: 'Gereed',
  DONT_SHOW_ALERT_KEY: 'Niet meer tonen',
  DOWNLOAD_COLUMN_HEADER_KEY: 'Downloaden',
  DOWNLOAD_APP_TITLE_KEY: 'U kunt de app hier downloaden:',
  DOWNLOAD_LINK_KEY: 'Download HP Click hier gratis', // Download HP Click for free here
  DOWNLOAD_HP_SMARTSTREAM_KEY: 'Download HP SmartStream', // Download HP SmartStream
  DOWNLOAD_INSTR_KEY:
    'Zorg ervoor dat HP Click is geïnstalleerd voordat u doorgaat', // Make sure you have HP Click installed before continuing
  DOWNLOAD_SMARTSTREAM_KEY: 'Download HP SmartStream', // Download HP SmartStream
  DROPBOX_KEY: 'Dropbox',
  DROPBOX_IMPORT_KEY: 'Importeren in Dropbox',
  DROPBOX_UPLOAD_DIALOG_DESCRIPTION_KEY:
    'De afbeeldingsgrootte moet kleiner zijn dan 1 GB. We accepteren pdf-, png-, jpg-, svg- en tiff-formaten.',
  DREAMSTIME_KEY: 'dreamstime',
  DREAMSTIME_SEARCH_TITLE: 'Dreamstime-zoekopdracht',
  DREAMSTIME_TITLE_KEY: 'Dreamstime',
  DREAMSTIME_IMAGES_KEY: 'Dreamstime afbeeldingen',
  DUPLICATE_KEY: 'Dupliceren',
  EACH_ITEM_PRICE_KEY:
    'Uw ontwerp bevat inhoud van een van onze premium content-providers. De gespecificeerde prijzen van elk element worden hieronder samengevat.',
  EDIT_DESIGN_BUTTON_TITLE_KEY: 'Ontwerp bewerken',
  EDIT_LOWERCASE_KEY: 'Bewerk',
  ERROR_DIALOG_VIEW_MESSAGE_TEXT:
    'Er is een fout opgetreden. Probeer het later opnieuw.',
  ERROR_IN_OPENING_PDF_FILE_TEXT:
    'Er is een fout opgetreden tijdens het openen van het geüploade PDF-bestand.',
  EMAIL_KEY: 'E-mail:',
  EMAIL_ADDRESS_KEY: 'E-mailadres:',
  EMAIL_CHECKBOX_MESSAGE:
    'Ik weet dat deze persoon begrijpt dat hij/zij e-mails van HP ontvangt namens mij of deze serviceprovider.',
  EXTRA_INFO_KEY: 'Extra info',
  EMAIL_NOTIFICATION:
    'U ontvangt zo snel mogelijk een e-mail.De verwerking duurt maximaal 15 minuten.',
  EMAIL_DIALOG_MESSAGE:
    'Typ het e-mailadres van de persoon met wie u uw ontwerp wilt delen.',
  ENTER_KEY: 'Invoeren',
  EXISTING_FOLDER_KEY: 'Bestaande map',
  FACEBOOK_KEY: '  Facebook',
  FINAL_CHECK_DESCRIPTION_STRING_KEY:
    'Zorg dat u alle geselecteerde items voor u hebt voor u gaat afrekenen',
  FINAL_CHECK_TITLE_KEY: 'Laatste controle',
  FINISH_KEY: 'Voltooien',
  FINISH_LATER_KEY: 'Voltooi later', // Finish later
  FIRSTNAME: 'Voornaam', // First name
  FISCAL_NUM: 'Fiscaal nummer',
  FLIP_KEY: 'Spiegelen',
  FOR_KEY: 'voor',
  FORGOT_PASSWORD_KEY: 'Wachtwoord vergeten?',
  FOTOLIA_KEYWORDS_KEY: 'Trefwoorden:',
  FOLDER_NAME: 'Mapnaam',
  FOLDER_NAME_KEY: 'Mapnaam:',
  FOLDER_ALREADY_EXIST_KEY: 'Deze mapnaam bestaat al',
  FREE_POSTER_COMPLETE_MESSAGE_KEY:
    'Je hebt zojuist je gratis posterontwerp voltooid', // You've just completed your free poster design
  FREE_VECTOR_GRAPHICS_KEY: 'gratis vectorafbeeldingen', // free vector graphics
  GETTY_IMAGE_SEARCH_TITLE: 'Getty Image Zoeken', // Getty Image Search
  GOT_IT_MESSAGE_KEY: 'Oke, ik snap het',
  GROUP_ALL_KEY: 'Alles groeperen',
  GROUP_SCALE: 'Groep schalen',
  GIFT_WRAPS_KEY: 'Gift Wraps',
  GIVE_PROJECT_NAME_KEY: 'Geef uw project een naam',
  HEIGHT_KEY: 'Hoogte',
  HELP_KEY: 'Helpen',
  HELPER_TITLE_KEY_1:
    'Maak posterontwerpen op basis van een lege pagina of van miljoenen afbeeldingen en tekst. Upload uw eigen inhoud van lokale schijven, Dropbox of sociale media', // Create poster designs from a blank page or from millions of images and text. Upload your own content from local drives, Dropbox or social media
  HELPER_TITLE_KEY_3: 'Bekijk al uw ontwerpwerk op één plek', // See all your design work in one place
  HELPER_TITLE_KEY_4:
    'Klik op Volgende om een voorbeeld te bekijken en uw definitieve ontwerp te voltooien', // Click Next to preview and finish your final design
  HERE_KEY: 'hier', // here
  HELP_IMPROVE_KEY:
    'Help uw productiviteit en operatorefficiëntie te verbeteren en uit te breiden met kleurenproductie.', // Help improve your productivity and operator efficiency, and expand with color production.
  HIGH_QUALITY_KEY: 'Hoge kwaliteit', // High-quality

  IMAGES_TITLE_KEY: 'AFBEELDINGEN',
  IMPERIAL_KEY: 'Imperiaal',
  IMPORTING_KEY: 'Importeren van',
  INCHES_COLUMN_HEADER_KEY: 'Inches',
  INCHES_KEY: ' inches',
  INCHES_UNIT_STRING_KEY: 'in.',
  INVALID_EMAIL_ADDRESS_KEY: 'Ongeldig e-mailadres',
  INVALID_INFO_KEY: 'Voer de details in',
  INVALID_NAME_KEY: 'Ongeldige naam',
  INVALID_PRINTER_MODEL_KEY: 'Ongeldig printermodel', // Invalid printer model
  INVALID_SERIAL_NUMBER_KEY: 'Ongeldig serienummer', // Invalid serial number
  INAVLID_USER_TYPE_KEY: 'Ongeldig gebruikerstype', // Invalid user type
  INVALID_FILE_SIZE_ERROR_TEXT:
    'Het geselecteerde bestand is te groot. De maximale bestandsgrootte is 500 MB.',
  INSUFFICIENT_CREDITS_KEY: 'Onvoldoende credits',
  INSTAGRAM_KEY: 'Instagram',
  INSPIRATION_KEY: 'Inspiratie',
  I_STOCK_SEARCH_TITLE: 'iStock Zoeken',
  INVALID_FILETYPE_ERROR_TEXT:
    'Ongeldige bestandsindeling. Wij kunnen alleen werken met PDF-, JPG-, PNG-, SVG- en TIF-bestanden.',
  LANDSCAPE_KEY: 'Landschap',
  LANGUAGE_LABLE_KEY: 'Taal',
  LASTNAME: 'Achternaam',
  LEARN_MORE: 'Meer informatie',
  LEARN_THE_BASICS_KEY: 'Leer de basis',
  LEGAL_FOOTER_MESSAGE1_KEY:
    'Door het gebruik van deze site gaat u akkoord hieraan gebonden te zijn',
  LEGAL_FOOTER_MESSAGE2_KEY: 'Deze website voldoet aan de',
  LEGAL_FOOTER_MESSAGE3_KEY: 'en de',
  LENGTH_STRING_IN_INCHES_KEY: 'in',
  LINKED_IN_KEY: '  LinkedIn',
  LINKLABEL_TITLE_KEY: 'verandering',
  LINK_READER_APP_KEY: 'LinkReader App',
  LINK_READER_APP_DESCRIPTION_KEY:
    'Download de LinkReader-app om de content die u toevoegt te visualiseren.',
  LOADING_KEY: 'Laden...',
  LOADING_TEMPLATE_KEY: 'Sjabloon laden',
  LOGIN_NOW: 'Log nu in',
  LOCK_KEY: 'Vergrendelen',
  LOGIN_KEY: 'Aanmelden',
  LOGIN_PATTERN_DESIGN_KEY: 'Log in op Pattern Design', // Login to Pattern Design
  LOGIN_SUBTITLE_KEY: 'Log in om aangepaste prijs- en betalingsdetails te zien', // Login to see customized pricing and payment details
  LOGIN_DREAMSTIME_KEY: 'Log in op Dreamstime', // Login to Dreamstime
  LOGIN_VECTEEZY_KEY: 'Login to Vecteezy',
  LOGOUT_KEY: 'Uitloggen',
  MATERIAL_TITLE_KEY: 'MATERIAAL',
  MATERIAL_STRING_KEY: 'Materiaal',
  MEASUREMENT_KEY: 'Meting',
  METRIC_KEY: 'Metric',
  MINIMUM_ZOOM_WARNING:
    'Deze achtergrond kan niet verder worden verkleind omdat de minimale hoogte of breedte vereist voor de volledige wand is bereikt.',
  MOBILE: 'Mobile',
  MODEL_TITLE_KEY: 'Model',
  MORE_INFO_TEXT_KEY: 'Meer informatie',
  MY_GIFTWRAPS_KEY: 'Mijn Gift Wraps',
  MY_WORK_KEY: 'Mijn werk',
  MY_WORK_SAVE_KEY: 'Your design has been saved to your My Work space',
  NAME_KEY: 'Naam:',
  NEXT_BUTTON_TITLE_KEY: 'VOLGENDE',
  NEW_FOLDER_KEY: 'Nieuwe map',
  NO_SHADOW_KEY: 'Geen schaduw',
  OBJECT_QUANTITY_KEY: 'Kwantiteit',
  OBJECTS_UPPER_CASE_KEY: 'VOORWERPEN',
  OK_KEY: 'OK',
  ORDER_SAMPLE_KEY: 'Proefdruk bestellen',
  ORDER_SAMPLE: 'Bestel een proefdruk',
  ORDER_SAMPLE_INFOLABEL_1:
    'Selecteer het stuk van de afbeelding die u wilt bestellen als een voorbeeld',
  ORDER_SAMPLE_INFOLABEL_2:
    'U ontvangt een e-mail met een close-up weergave van uw project op ware grootte',
  ORDER_SAMPLE_INFOLABEL_3:
    'Dit zal u helpen om de kwaliteit en resolutie te evalueren',
  ORDER_SAMPLE_NOW_BUTTON_TITLE: 'Proefdruk nu bestellen',
  ORDER_SAMPLE_EMAIL_DESCRIPTION:
    'Ontvang een e-mail met een close-up van het project op ware grootte. Zo kunt u de kwaliteit/resolutie evalueren.',
  ORIENTATION_KEY: 'Oiëntering',
  OTHER_PRINTING_OPTIONS: 'Andere afdrukopties',
  PASSWORD_KEY: 'Wachtwoord',
  PATTERN_COLOR_KEY: 'Patroon kleur',
  PATTERN_DESIGN_TITLE_KEY: 'Pattern Design',
  PATTERNS_FOR_KEY: 'patronen voor',
  PDF_GENERATION_ERROR_MESSAGE_KEY:
    'Kan pdf niet genereren. Probeer het opnieuw.', // Failed to generate pdf. Please try again.
  PHOTOS_KEY: "FOTO'S", // PHOTOS
  PHOTO: 'foto', // photo
  PHONE: 'Telefoon', // Phone
  PHOTO_UPLOAD_DIALOG_CHECKBOX_TEXT_KEY:
    'Het copyright van deze afbeelding berust bij mij en ik ga akkoord met de',
  PHOTO_UPLOAD_DIALOG_DESCRIPTION_FOR_SCENE_KEY:
    'De afbeeldingsgrootte moet kleiner zijn dan 500 MB. We accepteren png-, jpg-, tiff-, svg- en pdf-formaten.', // The image size should be less than 500 MB. We accept png, jpg, tiff, svg and pdf formats.
  PIXEL_COLUMN_HEADER_KEY: 'Pixel',
  PININTEREST_KEY: '  Pinterest',
  PLACEHOLDER_CM_STRING_KEY: 'cm',
  PLACEHOLDER_EMAIL_KEY: 'i.e name@email.com',
  PLACEHOLDER_ENTER_TEXT_KEY: 'Voeg hier tekst in...',
  PLACEHOLDER_EXTRA_INFO_KEY:
    'd.w.z. sommige belangrijke dingen die u moet melden aan de afdrukwinkel',
  PLACEHOLDER_INCHES_STRING_KEY: 'in',
  PLACEHOLDER_NAME_KEY: 'i.e John Smith',
  PLACEHOLDER_PROJECT_NAME: 'Mijn Poster',
  PORTRAIT_KEY: 'Portret',
  POSITION: 'Positie',
  PREMIUM_IMAGES_TITLE_KEY: 'Premium afbeeldingen:',
  PRE_CHECK_SAVE_DIALOG_TITLE: 'Sla uw project op',
  PRE_CHECK_SAVE_DIALOG_MESSAGE:
    'Het project bevat wijzigingen die moeten worden opgeslagen voordat u verdergaat.',
  PRICE_COLUMN_HEADER_KEY: 'Prijs',
  PRINTER_SERIAL_NUMBER_KEY: 'Serienummer van de printer*', // Printer serial number*
  PRINTING_ENABLE_DETAILS_KEY:
    'Om afdrukken mogelijk te maken, hebben we nog een paar details nodig', // To enable printing we just need a few more details
  PRINTER_MODELS_KEY: 'Printermodellen*', // Printer models*
  PROCESSING_KEY: 'Verwerken...',
  PROCESSING_ALERT_TXT:
    'Sluit dit venster niet terwijl we uw ontwerp verwerken', // Do not close this window while we are processing your design
  PROCESSING_ALERT_TXT2:
    'Nadat de verwerking is voltooid, wordt HP Click automatisch geopend en wordt uw bestand gedownload', // Once processing has been completed, HP Click will open automatically and start downloading your file
  PROCESSING_DONE: 'Je bent bijna klaar!', // You are almost done!
  PROCESSING_FILE_TXT: 'Uw bestand wordt verwerkt.', // Your file is being processed.
  PROCESSING_TIME_TXT:
    'Dit kan enige tijd duren terwijl we uw creatie samenstellen om de beste beeldkwaliteit te garanderen', // This may take some time as we are composing your creation to ensure the best image quality
  PROCESSING_ALERT_TXT3: 'Uw PDF wordt automatisch naar uw computer gedownload', // Your PDF will be automatically downloaded to your computer
  PROCESSING_ALERT_TXT4:
    'Vergeet niet dat u uw JDF-verbinding kunt configureren voor automatisering in de instellingen', // Remember you can configure your JDF connection for automation in settings
  PREMIUM_CONTENT_KEY: 'Premium Inhoud',
  PREVIEW_KEY: 'Voorbeeld',
  PROFESSIONAL_USE_TITLE_KEY: 'professioneel gebruik.',
  PROJECT_NAME_KEY: 'Projectnaam',
  PROJECT_NAME: 'Projectnaam:',
  PROJECT_ALREADY_EXIST_KEY: 'Deze projectnaam bestaat al',
  NONUNIQUE_PROJECT_NAME_MESSAGE: 'Deze projectnaam bestaat al',
  NONUNIQUE_FOLDER_NAME_MESSAGE: 'Deze mapnaam bestaat al',
  PIXELATION_WARNING_KEY: 'Pixelatiewaarschuwing',
  PIXELATED_TEXT_BEFORE_SUBMIT_KEY:
    'Vanwege de resolutie van uw geüploade foto kan uw huid vervormd of vervormd zijn. Upload een afbeelding van goede kwaliteit en vermijd het uitrekken van de afbeelding om ervoor te zorgen dat er geen onscherpte ontstaat. Als u tevreden bent met het voorbeeld en wilt doorgaan, kunt u doorgaan met verzenden.',
  REGISTER_CONTACTINFO: 'Contactgegevens',
  REGISTER_INFO: 'Informatie registreren',
  REGISTER_PATTERNSUB1: 'Als een HP-klant van waarde,',
  REQUIRED_FIELDS_KEY: '*Verplichte velden', // *Required fields
  REQUIRED_FIELDS_TEXT_KEY: 'Verplichte velden', // *Required fields
  REQUIRED_STRING_KEY: 'VEREIST',
  RECOLOR_KEY: 'Opnieuw kleuren',
  RADICALLY_SIMPLE_KEY: 'Radicaal eenvoudige printsoftware', // Radically simple printing software
  RIPSELECTION_HEAD:
    'Dit is de eerste keer dat u de compatibele afdruksoftware van uw voorkeur selecteert', // This is your first time, select your prefered compatible printing software
  RIPSELECTION_DESC:
    'Uw selectie wordt uw standaardafdrukoptiepad voor toekomstige afdrukken. Wijzigingen kunnen later in de instellingen worden aangebracht', // Your selection will become your default printing option path for future print outs. Changes can be made later in settings
  REGISTER_COMPANYINFO: 'Bedrijfsinformatie', // Company information
  REGISTER_KEY: 'Registreren', // Register
  REGISTER_NOW: 'Registreren nu', // Register now
  REOLOR_KEY: 'Opnieuw kleuren',
  REQUEST_SAMPLE_KEY: 'Vraag een monster aan',
  RESIZE_KEY: 'Resize',
  RESIZE_ARBITRARILY_KEY: 'Resize Willekeurig', // Resize Arbitrarily
  RESIZE_PROPORTIONALLY_KEY: 'Formaat proportioneel wijzigen', // Resize Proportionally
  REVIEW_AND_SUBMIT_KEY: 'Controleer en Verzend', // Review and Submit
  REQUEST_FOR_QUOTATION: 'Offerteaanvraag',
  RIGHT_LOGO_TEXT_KEY: 'door',
  ROTATE_KEY: 'Draaien',
  ROTATE_LEFT_KEY: '90° naar links draaien',
  ROTATE_RIGHT_KEY: '90° naar rechts draaien',
  ROTATION_KEY: 'Draaiing',
  ROWS_COLUMN_LABEL_STRING_KEY: 'Rijen en kolommen',
  ROYALTY_FREE_KEY: 'royalty vrij',
  ROYALTY_KEY: 'royalty',
  SALUTATION: 'Begroeting',
  SAVE_KEY: 'Opslaan',
  SAVING_KEY: 'Opslaan...',
  SAVE_INSPIRATION: 'Inspiratie opslaan', // Save inspiration
  SAVE_TEMPLATE: 'Sjabloon opslaan', // Save template
  SAVE_DIALOG_TITLE: 'Sla uw project op',
  SAVE_PROJECT_NAME_KEY: 'Sla eerst uw project op',
  SAVEDIALOG_MESSAGE:
    'Meld u aan om het project op te slaan. Als u nog geen account hebt, zullen wij u helpen bij het maken van een account. Uw werk zal hierbij niet verloren gaan.',
  SEAMLESS_KEY: 'naadloos',
  SCALE_INFO_STRING_KEY: 'Schaal de afbeelding zodat deze op uw ontwerp past',
  SCALE_KEY: 'Schalen',
  SCALE_ALL_KEY: 'Alles schalen',
  SCALE_TO_FILL_KEY: 'Schaal om te vullen',
  SEARCH_BUTTON_TITLE_KEY: 'Zoeken',
  SELECT_CUSTOM_SIZE_KEY: 'Selecteer aangepast formaat', // Select custom size
  SELECT_CUSTOM_KEY: 'Op maat', // Custom
  SEARCH_TITLE: 'Zoeken',
  SELECTED_IMAGE_KEY: ' Geselecteerde afbeelding: ', // Selected Image:
  SELECT_GIFT_WRAPS_SIZE_KEY: 'Selecteer de maat Gift Wraps', // Select Gift Wraps size
  SELECT_COUNTRY: 'Selecteer Land', // Select Country
  SELECT_SALUTATION: '---Kiezen---', // Select
  SELECT_POSTER_SIZE_KEY: 'Selecteer posterformaat', // Select poster size
  SELECT_PRINTING_OPTION_KEY: 'Selecteer de gewenste afdrukoptie', // Select your prefered printing option
  SEND_INSTALLATION_INSTRUCTION_KEY: 'Stuur me Installatie-instructies',
  SEND_TO_BACK_KEY: 'Naar achtergrond',
  SEND_KEY: 'Verzenden',
  SEND_TO_PRINT_TITLE_KEY: 'Verzenden om af te drukken',
  SET_SIZE_KEY: 'Formaat instellen',
  SETTINGS_KEY: 'Instellingen',
  SETTINGS_UPPERCASE_KEY: 'INSTELLINGEN',
  SHARE_KEY: 'Delen',
  SIGNED_IN_AS_KEY: 'Aangemeld als', // Signed in as
  SIGNIN_OR_REGISTER_SUBTITLE_KEY:
    'Log in of registreer om aangepaste prijs- en betalingsgegevens te bekijken', // Sign in or register to see customized pricing and payment details
  SIGN_UP_NOW_KEY: 'Meld je nu aan', // Sign up now
  SKIP_KEY: 'Overspringen', // Skip
  SOLID_COLORS_KEY: 'Effen Kleuren', // Solid Colors
  SQFT_UNIT_STRING_KEY: 'ft².',
  SQM_UNIT_STRING_KEY: 'm².',
  START_TOUR_KEY: 'Start rondleiding', // Start tour
  STATUS_MSG: 'Uw bestand is verzonden om af te drukken!', // Your file has been sent to print!
  SUBMIT_BUTTON_KEY: 'voorleggen',
  SHARE_LINK_LABEL: 'Selecteer het type koppeling dat u wilt delen',
  SHARE_EDIT_LINK: 'Koppeling voor bewerken',
  SHARE_VIEW_LINK: 'Koppeling voor weergeven',
  SHARE_YOUR_CREATION: 'Deel je creatie!', // Share your creation!
  STREET_ADD: 'woonadres', // Street address
  TARGET_VIEWING_HINT:
    '* Kijkafstand van het doel kan worden gewijzigd vanuit instellingen.',
  TERMS1_KEY: 'termen',
  TERMS2_KEY: 'HP-privacyverklaring',
  TERMS3_KEY: 'HP kennisgeving over rechten persoonsgegevens',
  TERMS_OF_USE_KEY: 'Gebruiksvoorwaarden',
  TERMS_OF_USE: 'Gebruiksvoorwaarden.',
  TEXT_ANCHOR_MIDDLE: 'Centrum', // Center
  TEXT_SHADOW_COLOR_KEY: 'Tekstschaduw Kleur', // Text shadow Color
  TEXT_UPPERCASE_KEY: 'TEKST', // TEXT
  TILE_KEY: 'Tegel',
  TOTAL_KEY: 'TOTAAL',
  TOTAL_PRICE_KEY: 'Totaal:',
  TRANSPARENCY_KEY: 'Transparantie',
  TEMPLATES_KEY: 'Sjablonen', // templates
  TEMPLATES_UPPER_CASE_KEY: 'SJABLONEN', // TEMPLATES
  THANK_YOU_KEY: 'Bedankt',
  TOUR_DESCRIPTION_TEXT:
    'Laat ons u door het ontwerpproces leiden. Vergeet niet dat u de rondleiding op elk gewenst moment opnieuw kunt openen door op het Help-pictogram te klikken', // Let us walk you through the design process. Remember you can re-open the tour at any time by clicking on the help icon
  TWITTER_KEY: '  Twitter',
  UNLOCK_KEY: 'Ontgrendelen',
  UNGROUP_KEY: 'Groep opheffen',
  UPDATE_TEXT_KEY: 'Bijwerken',
  UPLOAD_KEY: 'Afbeelding uploaden',
  UPLOAD_LOGO_KEY: 'Upload logo',
  UPLOAD_IMAGE_KEY: 'Upload je eigen afbeelding', // Upload your own image
  UPLOAD_UPPERCASE_KEY: 'UPLOADEN', // UPLOAD
  USER_NAME: 'Gebruikersnaam',
  USER_TYPE_TITLE_KEY: 'Wat voor type gebruiker ben je*',
  UNTILE_KEY: 'Onttegelen',
  UNSPLASH_SEARCH_TITLE: 'Unsplash Zoeken',
  VALIDITY_KEY: 'Geldigheid',
  VANILLA_LOGIN_DIALOG_KEY:
    'Doe gratis mee om uw ontwerp op te slaan en af te drukken en uw opgeslagen werk te bekijken', // Join for free to save and print your design and see your saved work
  VANILLA_PREVIEW_MESSAGE_KEY:
    'Dit is een voorbeeld van uw ontwerp. Controleer of het ontwerp definitief is voordat u doorgaat of selecteer Bewerken om wijzigingen aan te brengen', // This is the preview of your design, check the design is final before proceeding or select edit to make any changes
  VAT_KEY: 'BTW',
  VECTEEZY_TITLE_KEY: 'Vecteezy',
  VECTOR_KEY: 'vector',
  VIEW_FOTOLIA_KEY: 'Weergeven in Fotolia©',
  VIEW_GETTY_IMAGE_KEY: 'Bekijk in Getty Image©', // View in Getty Image©
  VIEW_I_STOCK_KEY: 'Bekijk in iStock©', // View in iStock©
  VIEW_DESIGN_DETAILS_KEY: 'Ontwerpdetails weergeven',
  VIEW_DESIGNER_PROFILE_KEY: 'Ontwerpprofiel bekijken',
  VIEW_PRICE_KEY: 'Prijs weergeven',
  VECTEEZY_SEARCH_TITLE: 'Vecteezy Search',
  WALL_POSTER_KEY: 'Wandposter',
  WALL_SIZE_TEXT_KEY: 'Wall size',
  WARNING_KEY: 'Waarschuwing',
  WEBSITE: 'Website',
  WIDTH_KEY: 'Breedte',
  YOU_CAN_ALWAYS_ACCESS: 'Je hebt altijd toegang tot je ontwerpen in',
  YOUR_NAME_KEY: 'Uw naam',
  YOUR_SELECTION_WILL_KEY:
    'Uw selectie wordt uw standaardafdrukpad voor toekomstige afdrukken.',
  YOUR_PROJECT_KEY: 'Uw project:',
  PROJECT_NAME_ERROR_TEXT: 'Geef een naam op voor het project.',
  PROJECT_FOLDER_ERROR_TEXT: 'Geef een naam op voor de projectmap.',
  PIXELATION_WARNING_SETTINGS_KEY: 'Pixelwaarschuwingsinstellingen',
  MINIMUM_VIEWING_DISTANCE_KEY: 'Minimale kijkafstand ',
  BACKGROUND_UPLOAD_KEY: ' achtergrond ',
  OBJECT_UPLOAD_KEY: ' voorwerp ',
  PHOTO_UPLOAD_KEY: ' photo ',
  NO_DREAMSTIME_ERROR_MESSAGE: 'Geen dreamstime Inhoud gevonden',
  NO_ELEMENT_ERROR_MESSAGE: 'Er is geen element gevonden.',
  NO_MORE_IMAGES_FOUND_KEY: 'Geen afbeeldingen meer gevonden',
  NO_PATTERN_ERROR_MESSAGE: 'Geen patronen gevonden.',
  ALREDY_HAVE_AN_ACCOUNT: 'Heeft u al een {0} -account?', // Already have a {0} account?
  CHANGE_MEASURING_SYSTEM_KEY: 'Wijzigen in {0}', // Change to {0}
  DOWNLOADS_KEY: '{0} downloads', //  {0} downloads
  HEX_COLOR_KEY: 'Hex kleur: {0}', // Hex color: {0}
  NEAR_KEY: 'in de buurt', // Near
  FAR_KEY: 'Ver', // Far
  CLOSE_UP_KEY: 'Detailopname', // Close Up
  PIXELATION_WARNING_DESCRIPTION1_KEY:
    'De afbeeldingen die u probeert te gebruiken, zijn kleiner of groter dan het ontwerpgebied dat u gebruikt.', // The images you are trying to use are either smaller or larger than the design area you are using.
  PIXELATION_WARNING_DESCRIPTION2_KEY:
    'Gebruik een afbeelding met een resolutie van 999 voor betere resultaten', // To get better results use a {0} X {1} resolution image
  VIEWS_KEY: '{0} weergaven', //  {0} views
  MESSAGE_KEY: 'Bericht:',
  COST_DESCRIPTION_MESSAGE_KEY:
    'Dit is de samenvatting van de kosten met betrekking tot de premium-inhoud die in uw ontwerp is opgenomen. {0} Door afwerking te selecteren, stemt u ermee in dat de volgende providers de volgende kosten in rekening worden gebracht.', // This is the summary of the cost related to the premium content included in your design. {0} By selecting finish you agree to be charged the following cost by the content providers.
  DEFAULT_PRINTING_OPTION_KEY: '{0} is uw standaardafdrukoptie,', //  {0} is your default printing option,
  CONFIRM_DREAMSTIME_ACCOUNT_KEY: 'Heb je nog geen Dreamstime-account?', // Don't have a Dreamstime account yet?
  REGISTER_PATTERNSUB2:
    ' u krijgt $ 100 aan afbeeldingen met een hoge resolutie {0} om te helpen met al uw creatieve behoeften!', // you will revieve $100 worth of high-resolution images {0} to help with all your creative needs!
  REGISTER_PATTERNSUB3:
    "Meld u vandaag en in de loop van de komende 30 dagen aan, download creatieve bestanden uit onze inhoudsbasis van 25 miljoen foto's en ontdek hoe {0} u kan helpen aan uw creatieve behoeften te voldoen.", // Sign up today and over the course of the next 30 days, download creative files from our content base of 25 million photos, and see how {0} can help you meet your creative needs.
  ZOOM_WARNING_PIXELATED_TEXT:
    'U hebt de afbeelding zodanig vergroot dat de afdruk grof lijkt op een afstand van {0} {1} * (de huidige afdrukresolutie is {2} dpi).',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_TEXT:
    'De aanbevolen kijkafstand is {0} {1}. Als deze afstand u niet past, verkleint u de schaal van de afbeelding of het formaat van uw wand.',
  ZOOM_WARNING_RECOMMENDED_VIEWING_DISTANCE_LAPTOP_TEXT:
    'De aanbevolen kijkafstand is {0} {1} Als dit niet geschikt is, verkleint u de schaal van deze afbeelding.', //  The recommended viewing distance would be {0} {1} If this is not appropriate, please decrease the scale of this image.
  ZOOM_WARNING_VALID_IMAGE_TEXT:
    'U wordt aangeraden een minimale afbeeldingsgrootte van {0} x {1} pixels te gebruiken.',
  UPLOAD_STATUS: '{0}% van {1}MB', //  {0}% of {1}MB
  REGISTER_TO: 'Registreren bij {0}', // Register to {0}
  MINIMUM_DIMENSIONS_KEY: 'De minimale afmetingen zijn {0} (b) bij {1} (h).',
  MINIMUM_HEIGHT_KEY: 'De minimale hoogte is {0}.',
  MINIMUM_WIDTH_KEY: 'De minimale breedte is {0}.',
  MAXIMUM_DIMENSIONS_KEY: 'Maximale afmetingen zijn {0} (w) met {1} (h).',
  MAXIMUM_WIDTH_KEY: 'De maximale breedte is {0}.',
  MAXIMUM_HEIGHT_KEY: 'De maximale hoogte is {0}.',
  INVALID_NUMBER_ERROR_TEXT_KEY: 'Geef numerieke afmetingen groter dan nul op.',
  PROCESSING_FAILED: 'De verwerking is mislukt. Probeer het later opnieuw',
  MULTIPAGE_PDF_NOT_SUPPORTED_TEXT:
    "PDF-bestanden met meerdere pagina's worden niet ondersteund.",
  ENCRYPTED_PDF_NOT_SUPPORTED_TEXT:
    "Sorry, versleutelde pdf's worden niet ondersteund.",
  DROPBOX_UPLOAD_PROGRESS_KEY: 'Importeren van bestand {0} van {1}',
  RECOLORING_KEY: 'Opnieuw aan het kleuren...',
  TEXT_COLOR_KEY: 'Tekst kleur', // Text Color
  SOLID_COLOR_KEY: 'Effen kleur', // Solid Color
  AUTHENTICATE_DIALOG_TITLE: 'Deze inhoudsbron is beveiligd met een wachtwoord',
  AUTHENTICATE_FAILED_MESSAGE: 'Verificatie mislukt!',
  DROPBOX_IMPORT_ERROR_HEADER:
    'Er is een probleem opgetreden bij het importeren van bepaalde bestanden',
  RIPS_BLOCK1: 'Thrive, ProductionHouse & Poster Shop v11 12+ patch &',
  RIPS_BLOCK2:
    'HP Edition Flexi 12 with SP1 HP Edition Flexi 11 + patch under demand',
  RIPS_BLOCK3: 'GrandRIP 10.2 and higher VisualRIP+ 10.2 and higher',
  RIPS_BLOCK4: 'Production Server 9(v9.02.6196) and higher',
  RIPS_BLOCK5: 'Ergosoft RIP 15',
  RIPS_BLOCK6: 'PrintFactory 5',
  SAI_KEY: 'SAi',
  ONYX_KEY: 'ONYX',
  CALDERA_KEY: 'CALDERA',
  COLOR_GATE_KEY: 'ColorGATE',
  ERGOSOFT_KEY: 'ergosoft',
  PRINT_FACTORY_KEY: 'PrintFactory',
  HP_FEEDBACK_TEXT: 'We horen graag van je', // We would love to hear from you
  FEEDBACK_QUERY_TEXT:
    'Over het algemeen, hoe tevreden bent u in het algemeen over ons?', // Overall, how satisfied are you with us?
  VERY_SATISFIED_BUTTON_TEXT: 'Erg Tevreden', // Very Satisfied
  SATISFIED_BUTTON_TEXT: 'Tevreden', // Satisfied
  DISSATISFIED_BUTTON_TEXT: 'Ontevreden', // Dissatisfied
  VERY_DISSATISFIED_BUTTON_TEXT: 'Zeer Ontevreden', // Very Dissatisfied
  FEEDBACK_IMPROVE_TEXT: 'Wat kunnen we doen om te verbeteren?', // What can we do to improve?
  FEEDBACK_PRIVACY_INFO_TEXT: 'Privacyverklaring', // Privacy Statement
  FEEDBACK_PLACEHOLDER_TEXT:
    'We beoordelen uw feedback om onze producten te verbeteren, dus deel geen persoonlijke gegevens of vertrouwelijke / bedrijfseigen inhoud',
  DEFAULT_PROJECT_NAME: 'Project',
  INSPIRATION_SIZE_CHANGE_WARNING:
    'Deze Inspiration-sjabloon wordt geleverd met een standaardformaat van {0} X {1} {2}. Uw paginaformaat wordt automatisch aangepast aan dit sjabloon.',

  // Laptop strings
  CHOOSE_YOUR_LAPTOP_KEY: 'Kies je laptop',
  SHOW_ALL_KEY: 'Show all',
  Go_BACK_KEY: ' Go back',
  FIRST_NAME_KEY: 'Voornaam',
  LAST_NAME_KEY: 'Achternaam',
  PHONE_NUMBER_KEY: 'Telefoonnummer',
  POSTAL_ADDRESS: 'postadres',
  COMPANY_NAME: 'Bedrijfsnaam',
  INVALID_PHONE_NUMBER_KEY: 'Ongeldig telefoonnummer',
  INVALID_POSTAL_ADDRESS: 'Ongeldig postadres',
  INVALID_COMPANY_NAME: 'Ongeldige bedrijfsnaam',
  TERMS_AND_CONDITIONS: 'Ik accepteer de algemene voorwaarden',
  INVOICE_UPLOAD: 'Factuur uploaden',
  INVOICE_FILE_MISSING: 'Factuurbestand ontbreekt',
  TURKEY_STRING1:
    "* HP' nin veri toplama ilkeleri hakkında daha detaylı bilgi için, HP ",
  PRIVAY_STATEMENT_LINK: 'Gizlilik Bildirimi',
  TURKEY_STRING2: "' ne göz atabilirsiniz.",
  TURKEY_STRING:
    '* U kunt gedetailleerde informatie vinden over de gegevensverzamelingsprincipes van HP op HP',
  PRIVACY_STATEMENT_LINK1: 'Privacy Statement',
  PERSONAL_INFORMATION_CONDITION:
    'Ik accepteer dat mijn persoonlijke gegevens met HP worden gedeeld zodat HP contact met me op kan nemen over nieuwe campagnes van HP.*',
  SERVICE_PROVIDER_CONDITION:
    'Ik accepteer dat de gegevens die ik verschaf, gedeeld kunnen worden met service providers voor het print- en leveringsproces.*',
  ORDER_DESIGN: 'Ontwerp bestellen',
  SUBMIT_YOUR_DESIGN: 'Je ontwerp indienen',
  SUBMISSION_DESIGN_ORDER: 'Inzending voor ontwerpbestelling',
  ENTER_REQUIRED_FIELDS_KEY: 'Voer de vereiste velden in',
  ADDRESS_KEY: 'Adres',
  INVALID_ADDRESS_KEY: 'Ongeldig adres',
  CITY_KEY: 'Plaats',
  INVALID_CITY_KEY: 'Ongeldige plaats',
  COUNTRY_KEY: 'Land',
  STATE_KEY: 'Provincie',
  ZIP_KEY: 'Postcode',
  INVALID_ZIP_KEY: 'Ongeldige postcode',
  ORDER_NUMBER: 'Bestelnummer',
  YOUR_DETAILS_KEY: 'Jouw details',
  APPLY_DESIGN_COMPETITION: 'Meedoen aan de ontwerpwedstrijd',
  NOTICE_KEY: 'Merk op:',
  CAUTION_FOR_LAPTOP_SELECTION:
    'Voor een pc-skin die perfect is aangepast aan de uwe, moet u het exacte model selecteren dat overeenkomt met de aankoop, zoals te zien op de factuur.',
  RESTART_PROJECT_ALERT_TITLE: 'Een project herstarten?',
  DISCARD_ALERT_MESSAGE: 'Je huidige project wordt verwijderd',
  RESTART: 'Herstarten',
  INSPIRATION_SIZE_CHANGE_WARNING_TITLE: 'Paginaformaat Waarschuwing!',
  MODIFY_SIZE_WARNING:
    'Als u de grootte van dit ontwerp wilt wijzigen, kunt u dit doen op het tabblad "Instellingen". Ontwerpelementen moeten mogelijk worden bewerkt om aan te passen aan de gewenste afmetingen.',
  RANDOMIZE_KEY: 'Randomize',
  MATERIAL_CHOICE_APPLIED: 'Materiaalkeuze toegepast.',
  FEEDBACK_PERMISSION_STRING_KEY:
    'I grant permission to HP to contact me about my feedback',
  BLOCKCHAIN_STRING: 'Blockchain',
  CERTIFICATE_STRING: 'certificaat van',
  AUTHENTICITY_STRING: 'authenticiteit',
  PLEASE_WAIT: 'Wacht even',
  PROTECTING_YOUR_DATA: 'je gegevens aan het beschermen...',
  SEARCH_YOUR_LAPTOP_KEY: 'Doorzoek uw laptop', // Google translated
  PRODUCT_SEARCH_ERROR_MESSAGE_KEY:
    'Oops! We konden geen laptops vinden voor uw zoekopdracht.', // Google translated

  Arabic: 'عربى',
  Bulgarian: 'български',
  Catalan: 'Català',
  Chinese: '中文',
  'Chinese Simplified': '简体中文',
  Danish: 'Dansk',
  Dutch: 'Nederlands',
  English: 'English',
  Estonian: 'Eesti keel',
  Finnish: 'Suomalainen',
  French: 'Français',
  German: 'Deutsch',
  Greek: 'Ελληνικά',
  Hebrew: 'עברית',
  Italian: 'Italiano',
  Japanese: '日本人',
  Korean: '한국어',
  Norwegian: 'Norsk',
  Polish: 'Polskie',
  Portuguese: 'Português',
  Russian: 'русский',
  Spanish: 'Español',
  Swedish: 'Svenska',
  Thai: 'ไทย',
  Turkish: 'Türkçe',
  Georgian: 'ქართული',

  // new
  ZOOM_IN_KEY: 'In Zoomen', // Zoom In
  ZOOM_OUT_KEY: 'Uitzoomen', // Zoom Out
  ADOBE_STOCK_SEARCH_TITLE: 'Adobe Stock Search', // Adobe Stock Search
  HP_MOSAIC_SEARCH_TITLE: 'HP mozaïek', // HP mosaic
  CHOOSE_YOUR_LAPTOP_FAMILY_KEY: 'Kies uw laptopfamilie', // Choose your laptop family
  CHOOSE_FROM_DEVICE_KEY: 'Kies uit apparaat', // Choose from device
  SERIAL_NUMBER_KEY: 'Serienummer',
  LOCKED_PROJECT: 'Vergrendeld project',
  LOCKED_MESSAGE:
    'Dit project is besteld en kan niet worden gewijzigd. Je kunt dit project enkel bekijken.',
  EXPIRED_PROJECT: 'Vervallen project',
  EXPIRED_MESSAGE: 'Dit project is vervallen.',
  DELETED_PROJECT: 'Verwijderd project',
  DELETED_MESSAGE: 'Dit project is verwijderd.',
  CHOOSE_GROUP_TYPE: 'Kies {0} type',

  //  wall covering
  ABOVE_ZERO_ERROR_TEXT_KEY: 'Geef een getal op hoger dan nul.',
  SIZE_KEY: 'Formaat',
  DISTANCE_FROM_KEY: 'Afstand van',
  MYROOM_UPPERCASE_KEY: 'MY ROOM',
  FURNITURE_KEY: 'Furniture',
  FIXTURES_KEY: 'Fixtures',
  ADD_A_WALL_KEY: 'Add a wall',
  SELECT_A_WALL_KEY: 'Select a Wall',
  LEFT_KEY: 'Links',
  RIGHT_KEY: 'Rechts',
  DELETE_WALL_KEY: 'Delete a wall',
  // CANVAS
  CHOOSE_CANVAS_TYPE_KEY: 'Choose canvas type',
  MAXIMUM_WALL_SIZE_KEY: 'Het maximale formaat van de wand is {0} {1}',
  ALERT_CANVAS_HEIGHT_EXCEEDS_KEY:
    'Hoogte van het foto op canvas overschrijdt de hoogte van de wand.',
  ALERT_CANVAS_WIDTH_EXCEEDS_KEY:
    'Breedte van het foto op canvas overschrijdt de breedte van de wand.',
  MAXIMUM_COLUMNS_ERROR_MESSAGE_KEY:
    'Maximum aantal kolommen voor de huidige breedte is {0}',
  MAXIMUM_ROWS_ERROR_MESSAGE_KEY:
    'Maximum aantal rijen voor de huidige hoogte is {0}',
  WALL_WIDTH_IS_LESS_THAN_CANVAS_WIDTH_ERROR_TEXT_KEY:
    'De wand is minder breed dan het foto op canvas.',
  WALL_MINIMUM_WIDTH_ERROR_TEXT_KEY:
    'De wand moet een minimale breedte hebben van {0} {1}.',
  WALL_MINIMUM_HEIGHT_ERROR_TEXT_KEY:
    'De wand moet een minimale hoogte hebben van {0} {1}.',
  WALL_HEIGHT_IS_LESS_THAN_CANVAS_HEIGHT_ERROR_TEXT_KEY:
    'Qua hoogte is de wand kleiner dan het foto op canvas.',
  MAXIMUM_WALL_HEIGHT_KEY: 'De maximale hoogte van de wand is {0} {1}.',
  FINISHING_KEY: 'Finishing',
  MIRROR_KEY: 'Mirror',
  NATURAL_KEY: 'Natural',
  ROWS_KEY: 'Rijen',
  COLUMNS_KEY: 'Kolommen',
  DEFAULT_WALL_SIZE_KEY: 'Default Wall Size',
  EDIT_KEY: 'Bewerken',
  TOP_KEY: 'Boven',
  BOTTOM_KEY: 'Onder'
};
